export default __webpack_public_path__ + "static/media/Natalia_Rachkovich.b8af1bf4.png";